import brandPortalMarketingInsiderPartnership from "@faire/web-api/routes/brand-portal/marketing/insider-partnership";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var InsiderFreeShippingIA = function InsiderFreeShippingIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "lu7149",
    defaultMessage: [{
      "type": 0,
      "value": "Le "
    }, {
      "children": [{
        "type": 0,
        "value": "partenariat Insider"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " est un programme que les marques peuvent rejoindre pour booster leur croissance. Elles offrent ainsi la livraison gratuite à davantage de membres Insider (les meilleurs acheteurs sur Faire), sans en assumer la totalité des coûts."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return InsiderPartnershipFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "5e16Bk",
    defaultMessage: [{
      "type": 0,
      "value": "En offrant la livraison gratuite à davantage de commerçants en tant que partenaire Insider, vous pouvez :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "MQrpjL",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Convertir de nouveaux clients :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " les commerçants sont 30 % plus susceptibles de commander vos produits lorsqu'ils voient que la livraison est gratuite."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "d2Bx+/",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Fidéliser vos clients existants :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " les commerçants passent 30 % de commandes répétées en plus lorsqu'ils bénéficient de la livraison gratuite. Ils commandent plus souvent et passent de plus grosses commandes."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "WQu+9o",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Gagner en visibilité auprès des meilleurs acheteurs sur Faire :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " les membres Insider génèrent 80 % des ventes sur Faire et commandent deux fois plus que les acheteurs qui ne sont pas membres Insider. Ils achètent principalement auprès de marques proposant la livraison gratuite."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "f8saKN",
    defaultMessage: [{
      "type": 0,
      "value": "En tant que marque, vous pouvez vous inscrire pour devenir partenaire Insider afin de vous associer à Faire. Ainsi, davantage de membres Insider bénéficieront de la livraison gratuite sur vos produits. Nous paierons la livraison gratuite sur les commandes Insider de la plateforme répondant aux conditions, et vous paierez la livraison gratuite sur les commandes Insider Faire Direct répondant aux conditions."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ojPt35",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez consulter la page "
    }, {
      "children": [{
        "type": 0,
        "value": "Partenariat Insider"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " de votre portail pour voir des estimations personnalisées du programme de livraison gratuite (couverture, coûts, ventes) si vous devenez partenaire Insider."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return InsiderPartnershipFormatting(chunks);
      }
    }
  })));
};
var InsiderPartnershipFormatting = function InsiderPartnershipFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMarketingInsiderPartnership(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};